<div id="_stateCF-CENTER_" class="my-2 px-2 text-1.25 w-1/2 flex flex-col border overlay-dark-30">
  <div>Communication Failed - Arbitration from 3rd Party may help</div>
  @for (informationRace of informationRacesTickedOff; track informationRace._id) {
    <div class="w-full flex flex-col" ng-if="cc.pageData.informationRacesTickedOff.length">
      <div ng-repeat="informationRace in cc.pageData.informationRacesTickedOff">
        <hr />
        Star System #{{ starSystemHash[informationRace.aboutRace.starSystemId].number }} - {{ informationRace.aboutRace.name }} ({{ informationRace.aboutRace.techLevel > 0 ? "High Tech" : "Low Tech" }})
        <div class="flex">
          <table class="w-1/2">
            <tr>
              <th>
                <label># of Attempts:</label>
              </th>
              <td>
                {{ informationRace.communicationAttemptCount || 0 }}
              </td>
            </tr>
            <tr>
              <th>
                <label>Communication State:</label>
              </th>
              <td>
                {{ informationRace.communicationState }}
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  }
  <!-- -->
  @empty {
    <div>No Failed Communication!</div>
  }
</div>
